// TaxRow.jsx
import React from 'react';
import { useEffect, useState } from 'react';

export default function TaxRow({
  customTax,
  onCustomTaxToggle,
  taxRate,
  onTaxRateChange,
  taxAmountFormatted,
  onTaxAmountTyping,
  onTaxAmountBlur,
  netInput,
  onNetTyping,
  onNetBlur,
  onNetFocus,
  errorText,
  warningText,
  required,
  includeZeroOption,
  value,
  onChange,
  onBlur,
  onFocus,
  errorTextAmount,
  disabled = false
}) {
  const [netStrVal, setNetStrVal] = useState(
    String(netInput).replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  const [amountStrVal, setAmountStrVal] = useState('');
  const [taxAmountStrVal, setTaxAmountStrVal] = useState('');
  
  useEffect(() => {
    setNetStrVal(String(netInput).replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','))
  }, [netInput])
  
  useEffect(() => {
    setAmountStrVal(String(value).replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','))
  }, [value])
  
  useEffect(() => {
    const parsed = parseFloat(String(taxAmountFormatted).replace(/,/g, ''));
    const rounded = isNaN(parsed) ? String(taxAmountFormatted) : parsed.toFixed(2);
    setTaxAmountStrVal(rounded.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
  }, [taxAmountFormatted])

  return (
    <>
      {/* Custom Tax Toggle */}
      <div className="form-row" style={{ marginTop: 20, alignItems: 'center' }}>
        <label className="form-input-label-expense" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={customTax}
            onChange={onCustomTaxToggle}
            style={{ marginRight: '8px', cursor: 'pointer' }}
          />
          Custom Tax Amount
        </label>
        <div style={{ fontSize: '12px', color: '#666', marginLeft: '10px' }}>
        </div>
      </div>

      {/* Amount and Tax Rate Row */}
      <div className="form-row" style={{ marginTop: 20 }}>
        <div className="form-input-expense">
          <label className="form-input-label-expense">Amount*</label>
          <input
            type="text"
            name="amount"
            className="form-input-field-expense input-numeric"
            placeholder="0,00"
            value={amountStrVal}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            required={required}
            disabled={disabled}
          />
          {errorTextAmount ? <div className="error-text">{errorTextAmount}</div> : null}
        </div>
        
        <div className="form-input-expense">
          <label className="form-input-label-expense">Tax Rate*</label>
          <select
            name="taxRate"
            className={`form-input-field-expense input-numeric ${customTax ? 'disabled-input' : ''}`}
            style={{width: 185}}
            value={taxRate}
            onChange={(e) => onTaxRateChange(e.target.value)}
            required={!customTax && required}
            disabled={customTax || disabled}
          >
            <option value="">Select rate</option>
            {includeZeroOption && <option value="0%">0%</option>}
            <option value="5.5%">5.5%</option>
            <option value="6%">6%</option>
            <option value="7%">7%</option>
            <option value="10%">10%</option>
            <option value="19%">19%</option>
            <option value="20%">20%</option>
            <option value="21%">21%</option>
          </select>
          {errorText ? <div className="error-text">{errorText}</div> : null}
          {warningText ? <div className="warning-text">{warningText}</div> : null}
        </div>
      </div>

      {/* Tax Amount and Total Amount Row */}
      <div className="form-row" style={{ marginTop: 20 }}>
        <div className="form-input-expense">
          <label className="form-input-label-expense">Tax Amount{customTax ? '*' : ''}</label>
          <input
            type="text"
            name="taxAmount"
            className={`form-input-field-expense input-numeric ${!customTax ? 'disabled-input' : ''}`}
            placeholder="0,00"
            value={taxAmountStrVal}
            onChange={onTaxAmountTyping}
            onBlur={onTaxAmountBlur}
            disabled={!customTax || disabled}
          />
        </div>

        <div className="form-input-expense">
          <label className="form-input-label-expense">Total Amount</label>
          <input
            type="text"
            name="netAmount"
            className="form-input-field-expense input-numeric"
            placeholder="0,00"
            value={netStrVal}
            onChange={onNetTyping}
            onBlur={onNetBlur}
            onFocus={onNetFocus}
            disabled={disabled}
          />
        </div>
      </div>
    </>
  );
}
